import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import BranchRepository from '@/shared/http/repositories/configuration/branch'
import BranchModel from '@/shared/models/configuration/branchmodel'
import BranchForms from './branch-form'

export default {
  name: 'Branch',
  mixins: [ActionsForm],
  data () {
    return {
      data: BranchModel,
      form: BranchForms
    }
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.description.maxlength)
    }
  },
  methods: {
    onLoad () {
      loading.push()
      BranchRepository.GetAllPaging(this.CompanySelected, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    }
    /*
    onCreate () {
      loading.push()
      BranchRepository.Create(this.data)
        .then(this.onResult)
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      BranchRepository.Update(this.data)
        .then(this.onResult)
        .catch(this.onException)
    },
    onDelete (obj) {
      loading.push()
      BranchRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    }
    */
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/branch/branch.js